import { FormlyTemplateOptions, FormlyFieldConfig } from '@ngx-formly/core';

export interface ISnRadialSliderFieldTemplateOptions extends FormlyTemplateOptions {
  change?(field: FormlyFieldConfig, angle: number): void;
}
